module.exports = __webpack_public_path__ + "img/25_59.f097f4d7.png";